import "./marketing.scss";
import { initFreeNutritionLabelMaker } from "./seo_recipes/free_nutrition_label_maker.js";
import { initFdaNetQuantityStatement } from "./fda_net_quantity_statement.js";

require.context("./images", true);
require.context("./seo_recipes/images", false, /\.(png|jpe?g|svg|webp)$/);

const DV_SATURATED_FATS_GRAMS = 20.0;
const DV_SUGAR_GRAMS = 100.0;
const DV_SODIUM_MILLIGRAMS = 2300.0;

// Behavior for Canadian FOP page
document.addEventListener("DOMContentLoaded", () => {
  const page = document.querySelector("html[data-view='pages#canadian_fop']");
  if (!page) return;

  const form = page.querySelector("#fopForm");
  const image = page.querySelector("#fopImage");
  const imageContainer = page.querySelector("#fopImageContainer");
  const notRequiredMessage = page.querySelector("#fopNotRequired");
  const missingValuesMessage = page.querySelector("#fopMissingValues");
  const pngDownload = page.querySelector("#pngDownload");
  const pdfDownload = page.querySelector("#pdfDownload");

  const collectValues = () => {
    const data = new FormData(form);

    const values = {
      servingSize: parseFloat(data.get("serving_size")),
      saturatedFat: parseFloat(data.get("sat_fat")),
      sugars: parseFloat(data.get("sugars")),
      sodium: parseFloat(data.get("sodium")),
      isMainDish: !!data.get("is_main_dish"),
      format: data.get("format"),
      language: data.get("language"),
      size: data.get("size"),
    };

    if (Object.values(values).some((v) => v === null || Number.isNaN(v))) {
      return null;
    }

    return values;
  };

  const updateFOPImage = () => {
    const values = collectValues();

    if (values === null) {
      missingValuesMessage.classList.remove("is-hidden");
      notRequiredMessage.classList.add("is-hidden");
      imageContainer.classList.add("is-hidden");
      return;
    } else {
      missingValuesMessage.classList.add("is-hidden");
    }

    const nutritionVariant = getNutritionVariant(values);
    const fopNotRequired = nutritionVariant === 0;

    imageContainer.classList.toggle("is-hidden", fopNotRequired);
    notRequiredMessage.classList.toggle("is-hidden", !fopNotRequired);

    if (fopNotRequired) return;

    const prefix = getFOPUrlPrefix(values, nutritionVariant);

    image.src = `${prefix}.png`;
    pngDownload.href = `${prefix}.png`;
    pdfDownload.href = `${prefix}.pdf`;
  };

  const getFOPUrlPrefix = (values, nutritionVariant) => {
    const { format, language, size } = values;

    const sizeVariant = {
      Horizontal: {
        large: 1,
        small: 6,
      },
      Vertical: {
        large: 3,
        small: 6,
      },
    }[format][size];

    const languageVariant = {
      Horizontal: {
        english_first: "BH",
        french_first: "HB",
        english_only: "EH",
        french_only: "FH",
      },
      Vertical: {
        english_first: "BV",
        french_first: "VB",
        english_only: "EV",
        french_only: "FV",
      },
    }[format][language];

    return `/canada-fop-variants/${format}/${sizeVariant}.${nutritionVariant}(${languageVariant})`;
  };

  const getNutritionVariant = (values) => {
    const threshold =
      values.isMainDish && values.servingSize >= 200 ? 0.3 : values.servingSize > 30 ? 0.15 : 0.1;

    const highFat = values.saturatedFat / DV_SATURATED_FATS_GRAMS >= threshold;
    const highSugar = values.sugars / DV_SUGAR_GRAMS >= threshold;
    const highSodium = values.sodium / DV_SODIUM_MILLIGRAMS >= threshold;

    if (highFat && highSugar && highSodium) {
      return 1;
    } else if (highFat && highSugar) {
      return 2;
    } else if (highSugar && highSodium) {
      return 3;
    } else if (highFat && highSodium) {
      return 4;
    } else if (highFat) {
      return 5;
    } else if (highSugar) {
      return 6;
    } else if (highSodium) {
      return 7;
    } else {
      return 0;
    }
  };

  form.addEventListener("change", updateFOPImage);
});

// Analytics for SEO recipes gallery page
document.addEventListener("DOMContentLoaded", () => {
  const isNutritionLabelMakerPage = document.querySelector(
    "html[data-view='pages#free_nutrition_label_maker']"
  );
  if (isNutritionLabelMakerPage) {
    initFreeNutritionLabelMaker();
  }

  const isNqsPage = document.querySelector("html[data-view='pages#fda_net_quantity_statement']");
  if (isNqsPage) {
    initFdaNetQuantityStatement();
  }
});
